import React from 'react';
import { Container, Row, Col, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Clock } from 'lucide-react';

const MerchantPending = () => {
    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md="8">
                    <Card className="text-center">
                        <CardBody>
                            <Clock size={48} color="#33bdbf" />
                            <CardTitle tag="h2" className="mt-3">Your merchant application is pending</CardTitle>
                            <CardText className="mt-3">
                                We are reviewing your application. Please check back later for approval.
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default MerchantPending;
